import moment from 'moment-timezone';
var Day;
(function (Day) {
    Day["Sunday"] = "Sunday";
    Day["Monday"] = "Monday";
    Day["Tuesday"] = "Tuesday";
    Day["Wednesday"] = "Wednesday";
    Day["Thursday"] = "Thursday";
    Day["Friday"] = "Friday";
    Day["Saturday"] = "Saturday";
})(Day || (Day = {}));
const weekdays = [
    Day.Monday,
    Day.Tuesday,
    Day.Wednesday,
    Day.Thursday,
    Day.Friday,
    Day.Saturday,
    Day.Sunday,
];
export function getBusinessHoursString(intervals) {
    return intervals.length
        ? intervals.map(({ start, end }) => `${start} - ${end}`).join(', ')
        : 'Closed';
}
export function getRegularHours(openingHours) {
    const businessHours = openingHours.reduce((acc, { opening_hour_type, start_date, intervals }) => {
        if (opening_hour_type !== 'regular') {
            return acc;
        }
        const day = moment.utc(start_date).day();
        acc[day > 0 ? day - 1 : 6] = getBusinessHoursString(intervals !== null && intervals !== void 0 ? intervals : []);
        return acc;
    }, []);
    const { list } = businessHours.reduce((acc, businessHoursString, index, arr) => {
        const nextBusinessHoursString = arr[index + 1];
        if (nextBusinessHoursString !== businessHoursString) {
            const isWeekend = acc.carry === Day.Saturday && businessHoursString === Day.Sunday;
            const isWeekdays = acc.list.length === 0 && index === 4;
            const key = (isWeekend && 'Weekend') ||
                (isWeekdays && 'Weekdays') ||
                (acc.carry && `${acc.carry} - ${weekdays[index]}`) ||
                weekdays[index];
            acc.list.push([key, businessHoursString]);
            acc.carry = null;
        }
        else if (acc.carry === null) {
            acc.carry = weekdays[index];
        }
        return acc;
    }, { list: [], carry: null });
    return list;
}
